import { DetailsView } from '../views/Details/details.view';
import { HomeView } from '../views/Home/home.view';
import { ProfileView } from '../views/Profile/profile.view';
import { ReviewView } from '../views/Review/review.view';
import { RouteType, type } from './Router';
import { addressRoutes } from './address.routes';
import { BenefitsView } from '../views/Benefits/benefits.view';
import { authRoutes } from './auth.routes';
import { chooseDeliveryTimeRoutes } from './chooseDeliveryTime.routes';
import { Routes } from './types';
import { SelectPickUpPoint } from '../views/SelectPickUpPoint/selectPickUpPoint.view';
import { OrdersView } from '../views/Orders/orders.view';
import { OpeningHoursView } from '../views/OpeningHours/openingHours.view';
import { purchasesRoutes } from './purchase.routes';
import { ChangePasswordView } from '../views/ChangePassword/changePassword.view';
import { ChangePasswordSuccessView } from '../views/ChangePasswordSuccess/changePasswordSuccess.view';
import { VerifyDeliveryView } from '../views/VerifyDelivery/verifyDelivery.view';
import { OrderHelpView } from '../views/OrderHelp/orderHelp.view';
import { helpRoutes } from './help.routes';
import { ChooseTransactionView } from '../views/ChooseTransaction/chooseTransaction.view';
import { OrderDetailsView } from '../views/OrderDetails/orderDetails.view';
import { NewsListView } from '../views/NewsList/newsList.view';
import { NewsDetailsView } from '../views/NewsDetails/newsDetails.view';
import { TermsAndConditionsView } from '../views/TermsAndConditions/termsAndConditions.view';
import { PrivacyPolicyView } from '../views/PrivacyPolicy/privacyPolicy.view';
import { ConfirmationOpeningHoursView } from '../views/ConfirmOpeningHours/confirmOpeningHours.view';
import { KnowServicesView } from '../views/KnowServices/knowServices.view';

export const routes: RouteType[] = [
  {
    id: 'home',
    path: Routes.Home,
    titleKey: 'pageTitles.orderState',
    component: HomeView,
    type: type.PUBLIC,
  },
  {
    id: 'verify-delivery',
    path: Routes.VerifyDelivery,
    titleKey: 'pageTitles.verifyPassage',
    component: VerifyDeliveryView,
    type: type.PUBLIC,
  },
  {
    id: 'order-details',
    path: Routes.Details,
    titleKey: 'pageTitles.orderDetails',
    component: DetailsView,
    type: type.PUBLIC,
  },
  {
    id: 'review-service',
    path: Routes.Review,
    titleKey: 'pageTitles.reviewDelivery',
    component: ReviewView,
    type: type.PUBLIC,
  },
  {
    id: 'opening-hours',
    path: Routes.OpeningHours,
    titleKey: 'pageTitles.openingHours',
    component: OpeningHoursView,
    type: type.PUBLIC,
  },
  {
    id: 'confirm-opening-hours',
    path: Routes.ConfirmationOpeningHours,
    titleKey: 'pageTitles.confirmOpeningHours',
    component: ConfirmationOpeningHoursView,
    type: type.PUBLIC,
  },
  {
    id: 'profile',
    path: Routes.Profile,
    titleKey: 'pageTitles.profile',
    component: ProfileView,
    type: type.SECURED,
  },
  {
    id: 'change-password',
    path: Routes.ChangePassword,
    titleKey: 'pageTitles.changePassword',
    type: type.SECURED,
    component: ChangePasswordView,
  },
  {
    id: 'orders',
    path: Routes.Orders,
    titleKey: 'pageTitles.orders',
    component: OrdersView,
    type: type.SECURED,
  },
  {
    id: 'order-help',
    path: Routes.OrderHelp,
    titleKey: 'pageTitles.orderHelp',
    component: OrderHelpView,
    type: type.SECURED,
  },
  {
    id: 'order-details',
    path: Routes.ChooseTransaction,
    titleKey: 'pageTitles.orderPaymentsDetails',
    component: ChooseTransactionView,
    type: type.SECURED,
  },
  {
    id: 'order-transaction-details',
    path: Routes.TransactionDetails,
    titleKey: 'pageTitles.orderPaymentsDetails',
    component: OrderDetailsView,
    type: type.SECURED,
  },
  {
    id: 'terms-and-conditions',
    path: Routes.TermsAndConditions,
    titleKey: 'pageTitles.termsAndConditions',
    component: TermsAndConditionsView,
    type: type.PUBLIC,
  },
  {
    id: 'privacy-policy',
    path: Routes.PrivacyPolicy,
    titleKey: 'pageTitles.privacy',
    component: PrivacyPolicyView,
    type: type.PUBLIC,
  },
  {
    id: 'benefits',
    path: Routes.Benefits,
    titleKey: 'pageTitles.benefits',
    component: BenefitsView,
    type: type.PUBLIC,
  },
  {
    id: 'pick-up-point',
    path: Routes.SelectPickUpPoint,
    titleKey: 'pageTitles.pickUp',
    component: SelectPickUpPoint,
    type: type.PUBLIC,
  },
  {
    id: 'change-password-success',
    path: Routes.ChangePasswordSuccess,
    titleKey: 'pageTitles.passwordRecoverySuccess',
    component: ChangePasswordSuccessView,
    type: type.PUBLIC,
  },
  {
    id: 'news-list',
    path: Routes.NewsList,
    titleKey: 'pageTitles.news',
    component: NewsListView,
    type: type.PUBLIC,
  },
  {
    id: 'services',
    path: Routes.Services,
    titleKey: 'pageTitles.benefits',
    component: KnowServicesView,
    type: type.PUBLIC,
  },
  {
    id: 'news-details',
    path: Routes.NewsDetails,
    titleKey: 'pageTitles.news',
    component: NewsDetailsView,
    type: type.PUBLIC,
  },
  ...helpRoutes,
  ...purchasesRoutes,
  ...addressRoutes,
  ...authRoutes,
  ...chooseDeliveryTimeRoutes,
];
